import {
  EnumTypeAccessRequest,
  UnlockEntityTypeEnum,
} from "@/enum/access_request";
import { TypeHistory } from "@/services/dtos/enums/accessRequest.enum";

export const UNLOCK_MODAL_TEST_ID: string = "request-unlock-modal";
export const UNLOCK_CONFIRM_TEST_ID: string = "request-unlock-confirm";
export const UNLOCK_LIST_TEST_ID: string = "request-unlock-list";
export const UNLOCK_SELECTED_TEST_ID: string = "request-unlock-selected";
export const UNLOCK_CONFIRM_APPROVE_TEST_ID: string = "unlock-confirm-approve";
export const UNLOCK_APPROVE_TEST_ID: string = "unlock-approve-button";
export const UNLOCK_TARGET_CARD_TEST_ID: string = "unlock-target-card";
export const UNLOCK_IN_PROGRESS_TEST_ID: string = "unlock-in-progress";

export const UNLOCK_ENTITY_TYPES: readonly UnlockEntityTypeEnum[] = [
  UnlockEntityTypeEnum.OPERATOR,
  UnlockEntityTypeEnum.USER,
];

export const UNLOCK_ENTER_KEY: string = "Enter";

export const UNLOCK_OPEN_ROW_KEYS: readonly string[] = ["Enter", " "];

export const UNLOCK_MIN_LAST_PAGE: number = 1;

export const UNLOCK_SEARCH_FIELD: string = "unlockSearch";

export const UNLOCK_PER_PAGE_OPTIONS: readonly number[] = [10, 20, 30, 40, 50];

export const UNLOCK_TAB_PARAMS = {
  PAGE: "unlockPage",
  PER_PAGE: "unlockPerPage",
  SEARCH: "unlockSearch",
} as const;

export const UNLOCK_ELIGIBLE_PAGE_SIZE: number = 20;

export const UNLOCK_SEARCH_DEBOUNCE_MS: number = 300;

export const UNLOCK_LOAD_MORE_THRESHOLD_PX: number = 48;

export const UNLOCK_EMPTY_CELL: string = "-";

export const UNLOCK_DATE_FORMAT: string = "dd/MM/yyyy";

export const UNLOCK_STORE_SCOPE = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  NONE: "NONE",
  SINGLE: "SINGLE",
  MANY: "MANY",
} as const;

export const UNLOCK_LIST_STATE = {
  STORES_FAILED: "STORES_FAILED",
  NO_STORE: "NO_STORE",
  PICK_STORE: "PICK_STORE",
  LOADING: "LOADING",
  FAILED: "FAILED",
  EMPTY: "EMPTY",
  ROWS: "ROWS",
} as const;

export const UNLOCK_TIMELINE_TYPE: Record<TypeHistory, EnumTypeAccessRequest> =
  {
    [TypeHistory.CREATION]: EnumTypeAccessRequest.CREATED,
    [TypeHistory.FEEDBACK]: EnumTypeAccessRequest.FEEDBACK,
    [TypeHistory.UPDATED]: EnumTypeAccessRequest.UPDATED,
  };
